export enum ConfigActionType {
  SET_CONFIG_FILE = 'SET_CONFIG_FILE',
}
